// extracted by mini-css-extract-plugin
export default {"container":"wD-z","dimension":"xD-z","dimensionLabels":"yD-z"};